import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/mlap'

Styxie.Initializers.MlapSettingsGeogrids = {
  index: async(props) => {
    const { default: GeogridsSettings } = await import('@/vue_widgets/mlap/settings/geogrids/index.vue')
    createVueApp(GeogridsSettings, { props, sidebar })
  }
}
